import React, { useState, useEffect } from "react";
import { invokeApi } from "../../../../bl_libs/ApiCalling";
import { withRouter } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import CircularProgress from "@material-ui/core/CircularProgress";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import UserCard from "./User-Card/UserCard";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    // maxWidth: 345,
  },
  paper: {
    padding: theme.spacing(2),
    textAlign: "center",
    color: theme.palette.text.secondary,
  },
  title: {
    marginLeft: "30%",
  },
  ratings: {
    marginLeft: "32%",
  },
  p_img: {
    width: "100px",
    height: "100px",
    marginLeft: "36%",
    borderRadius: "100%",
  },
}));

function CustomerDetailcomponent(props) {
  const [isLoading, setIsLoading] = useState(true);
  const [Detail, setDetail] = useState();
  const classes = useStyles();

  const FetchCustomerDetail = () => {
    setIsLoading(true);
    const token = localStorage.getItem("token");
    let requestObj = {
      path: `/api/admin/detail_customer/${props.location.state.id}`,
      method: "GET",
      headers: {
        "x-sh-auth": token,
      },
    };
    invokeApi(requestObj).then((res) => {
      console.log(res, "RESPONSE");
      setDetail(res.customer_detail);
      setIsLoading(false);
    });
  };

  const HitCompanyActivate = () => {
    const token = localStorage.getItem("token");
    let requestObj = {
      path: `/api/admin/edit_customer/${props.location.state.id}`,
      method: "POST",
      headers: {
        "x-sh-auth": token,
      },
    };
    let postData = {
      is_active: "1",
    };
    requestObj["postData"] = postData;
    setIsLoading(true);
    invokeApi(requestObj).then((res) => {
      if (res.code === 200) {
        FetchCustomerDetail();
      }
    });
  };

  const HitCompanyDeactivate = () => {
    const token = localStorage.getItem("token");
    let requestObj = {
      path: `/api/admin/edit_customer/${props.location.state.id}`,
      method: "POST",
      headers: {
        "x-sh-auth": token,
      },
    };

    let postData = {
      is_active: "0",
    };
    requestObj["postData"] = postData;
    setIsLoading(true);
    invokeApi(requestObj).then((res) => {
      if (res.code === 200) {
        FetchCustomerDetail();
      }
    });
  };
  useEffect(() => {
    FetchCustomerDetail();
  }, []);

  if (isLoading) {
    return (
      <div className="Circular-Progress">
        <CircularProgress color="primary" />
      </div>
    );
  }

  return (
    <>
      <Grid container spacing={3}>
        <Grid item xs={12} sm={3} lg={4}></Grid>
        <Grid item xs={12} sm={6} lg={4}>
          <ArrowBackIcon
            className="backarrow pointer-point mt-20"
            color="primary"
            onClick={() => props.history.goBack()}
          ></ArrowBackIcon>
          <div className="rounded-box mt-40">
            <div className="heading-wrapper black-bg text-center">
              <h6 className="text-white">Customer Details</h6>
            </div>
            <UserCard
              customerDetails={Detail}
              HitCompanyActivate={HitCompanyActivate}
              HitCompanyDeactivate={HitCompanyDeactivate}
            />
          </div>
        </Grid>
        <Grid item xs={12} sm={3} lg={4}></Grid>
      </Grid>
    </>
  );
}

export default withRouter(CustomerDetailcomponent);
